var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils.js';
import { Badge as ShadcnBadge } from './primitives/badge';
var badgeVariants = cva('', {
    variants: {
        variant: {
            default: 'bg-primary text-primary-foreground [a&]:hover:bg-primary/90',
            secondary: 'bg-secondary text-secondary-foreground [a&]:hover:bg-secondary/90',
            destructive: 'bg-destructive text-destructive-foreground focus-visible:ring-destructive/70 dark:bg-destructive/60 [a&]:hover:bg-destructive/90',
            outline: 'border-border text-foreground [a&]:hover:bg-accent [a&]:hover:text-accent-foreground',
            ghost: '[a&]:hover:bg-accent [a&]:hover:text-accent-foreground',
            link: 'text-link underline-offset-4 [a&]:hover:underline',
            success: '[a&]:hover:opacity-90 bg-success text-primary-foreground',
            'success-light': '[a&]:hover:opacity-90 bg-success-light',
            info: '[a&]:hover:opacity-90 bg-info text-primary-foreground',
            'info-light': '[a&]:hover:opacity-90 bg-info-light',
            warning: '[a&]:hover:opacity-90 bg-warning text-yellow-950',
            'warning-light': '[a&]:hover:opacity-90 bg-warning-light',
            persimmon: '[a&]:hover:opacity-90 bg-persimmon text-primary-foreground',
            'persimmon-light': '[a&]:hover:opacity-90 bg-persimmon-light',
            danger: '[a&]:hover:opacity-90 bg-danger text-primary-foreground',
            'danger-dark': '[a&]:hover:opacity-90 bg-danger-dark text-primary-foreground',
            'danger-light': '[a&]:hover:opacity-90 bg-danger-light',
            muted: '[a&]:hover:bg-muted/90 bg-muted text-foreground/80',
            'muted-foreground': '[a&]:hover:bg-opacity-90 bg-muted-foreground text-muted',
            'info-alt': '[a&]:hover:opacity-90 bg-info-alt text-primary-foreground',
            'info-alt-light': '[a&]:hover:opacity-90 bg-info-alt-light',
            'info-alt2': '[a&]:hover:opacity-90 bg-info-alt2 text-primary-foreground',
            'info-alt2-light': '[a&]:hover:opacity-90 bg-info-alt2-light',
            // Outline variants
            'default-outline': 'bg-transparent border-primary text-primary [a&]:hover:bg-primary/10',
            'secondary-outline': 'bg-transparent border-secondary text-secondary-foreground [a&]:hover:bg-secondary/10',
            'destructive-outline': 'bg-transparent border-destructive text-destructive [a&]:hover:bg-destructive/10',
            'success-outline': 'bg-transparent [a&]:hover:bg-muted/90 border-success-foreground text-success-foreground',
            'info-outline': 'bg-transparent [a&]:hover:bg-muted/90 border-info-foreground text-info-foreground',
            'warning-outline': 'bg-transparent [a&]:hover:bg-muted/90 border-warning-foreground text-warning-foreground',
            'persimmon-outline': 'bg-transparent [a&]:hover:bg-muted/90 border-persimmon-foreground text-persimmon-foreground',
            'danger-outline': 'bg-transparent [a&]:hover:bg-muted/90 border-danger-foreground text-danger-foreground',
            'muted-outline': 'bg-transparent [a&]:hover:bg-muted/90 border-muted-foreground text-muted-foreground',
            'info-alt-outline': 'bg-transparent [a&]:hover:bg-muted/90 border-info-alt-foreground text-info-alt-foreground',
            'info-alt2-outline': 'bg-transparent [a&]:hover:bg-muted/90 border-info-alt2-foreground text-info-alt2-foreground',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});
function CustomBadge(_a) {
    var className = _a.className, variant = _a.variant, props = __rest(_a, ["className", "variant"]);
    return (<ShadcnBadge className={cn(badgeVariants({ variant: variant }), className)} variant={null} // Do not use the primitive variant. Variants are defined and handled here.
     {...props}/>);
}
export { CustomBadge as Badge, badgeVariants };
